import { findIndex, sortBy } from 'ramda'
import React from 'react'
import style from './styles/TeamList.module.scss'
import TeamCard from './TeamCard'

type Props = {
  teamList: Array<Member>
  isLoading: boolean
  isAuthenticated: boolean
  teamName: string
}

type Member = {
  description: string
  linkedin: string
  medshr: string
  name: string
  photo_url: string
  subtitle1: string
  twitter: string
}

// SORT OPTIONS
const MEDSHR_FILTERS: Array<string> = [
  'Dr. Asif Qasim',
  'Jude Venn',
  'George Ulmann',
  'Dr. Antonia Trent',
  'Janis Pereira',
  'James Atherton',
  'Paul Cook',
]

const EDITORS_FILTER = 'Apply now'

const TeamList = ({
  teamList = [],
  isLoading,
  isAuthenticated,
  teamName,
}: Props): React.ReactElement => {
  let list

  if (isLoading) return <div>Loading...</div>

  if (!teamList) return <div>No member</div>

  if (teamList.length > 0 && teamName) {
    if (
      teamName === 'editors' ||
      teamName === 'clinical-leaders' ||
      teamName === 'students'
    ) {
      list = sortEditors(teamList, EDITORS_FILTER)
    } else if (teamName === 'medshr') {
      list = sortMedshrTeam(teamList, {
        top: MEDSHR_FILTERS,
      })
    } else list = teamList
  }

  return (
    <ul className={style.container}>
      {list &&
        list.map((item: any, index: number): any => (
          <li key={index}>
            <TeamCard
              memberObj={item}
              teamName={teamName}
              isAuthenticated={isAuthenticated}
            />
          </li>
        ))}
    </ul>
  )
}

function mapListWithFilter(
  list: Array<Member>,
  options: Array<string>
): Array<Member> {
  return options
    .map(i => list[findIndex((member: Member): any => member.name === i, list)])
    .filter(i => typeof i !== 'undefined')
}

// SORT MEDSHR LIST
function sortMedshrTeam(members: Array<Member>, { top }): any {
  const topOfTheList = mapListWithFilter(members, top)
  const officeTeam = sortBy(
    x => x.subtitle2,
    members.filter(i => !top.includes(i.name))
  )

  return [...topOfTheList, ...officeTeam]
}

// SORT EDITORS
function sortEditors(members: Array<object>, filter: string): any {
  const newTeamList = [].concat(members)
  const editorsPage = findIndex(
    (member: any): any => member.name === filter,
    newTeamList
  )

  if (editorsPage) {
    const sliced = newTeamList.splice(editorsPage, 1)
    newTeamList.unshift(sliced[0])

    return newTeamList
  }
}

export { TeamList as default, sortEditors, sortMedshrTeam }
